import React from "react";

// Create a context for theme management
const ThemeContext = React.createContext({
  darkMode: false,
  toggleTheme: () => {},
});

export default ThemeContext;
